import { AuditFormControlTypeDto } from './auditFormControlType.dto';
import { AuditFormQuestionOptionDto } from './auditFormQuestionOptions.dto';
import { BaseDto } from '../base.dto';

export class AuditFormScheduleQuestionResponseDto extends BaseDto {
  auditFormScheduleId: number;
  auditFormId: number;
  userId: number;
  auditFormSectionId: number;
  auditFormQuestionId: number;
  auditFormQuestionOptionId: number;
  text?: string;
  sort?: number;
  controlType?: AuditFormControlTypeDto;
  questionIndex?: number;
  options?: AuditFormQuestionOptionDto[];
  selectedOption?: AuditFormQuestionOptionDto;
  selectedOptions?: AuditFormQuestionOptionDto[];
  answer?: string;
  isSelected?: boolean;
  comments?: string;
  photoUrl?: string;
}
